import { usePlan } from '@/contexts/PlanContext';

/**
 * Etiqueta de UI para "departamento" — se relabela a "Bodega" cuando la
 * organización tiene el módulo/perfil `bodegas` activo (decisión de diseño
 * documentada en WORK_CENTER_COSTANERA_BODEGAS_SCOPE_V1.md §3.1: el scope
 * `department` en sí es infraestructura genérica, pero la terminología visual
 * "Bodega" es exclusiva de ese vertical).
 *
 * El modelo de datos, las rutas, los permisos (`departments.*`) y los campos
 * de API (`department_id`, `manager_user_id`, etc.) NO cambian — esto es
 * puramente de presentación.
 */
export function useDepartmentLabel() {
  const { canUseModule } = usePlan();
  const isBodega = canUseModule('bodegas');
  return {
    isBodega,
    singular: isBodega ? 'Bodega' : 'Departamento',
    plural: isBodega ? 'Bodegas' : 'Departamentos',
    singularLower: isBodega ? 'bodega' : 'departamento',
    pluralLower: isBodega ? 'bodegas' : 'departamentos',
  };
}

export default useDepartmentLabel;
